import { Button } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
const AlertCloseButton = (props) => {
    return (!props.text
        ? <IconButton onClick={props.onClose} className="closeAlert">
                <CloseIcon />
              </IconButton>
        : <Button onClick={props.onClose} className="closeAlert" color="inherit" size="medium">
            {props.text}
            </Button>);
};
export default AlertCloseButton;
